import { render, staticRenderFns } from "./render.vue?vue&type=template&id=98bf810e&scoped=true"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"
import style0 from "./render.vue?vue&type=style&index=0&id=98bf810e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bf810e",
  null
  
)

export default component.exports